import { Flex, Button, Text, TextArea } from '@pega/cosmos-react-core';
import React from 'react';
import copy from 'copy-to-clipboard';
import { useDispatch, useSelector } from 'react-redux';
import { updateBannerInfo } from '../../../../redux/actions';
import pretty from 'pretty';
import { appState, SDKComponentProps } from '../../../../interfaces/common';
import useLocalTranslation from '../../../../hooks/useLocalTranslation';
import SDKInstallation from './SDKInstallation';

const InstallationTab: React.FC<SDKComponentProps> = (props: SDKComponentProps) => {
  const { widgetId } = useSelector((state: appState) => state.chatInfo);
  const { platform } = props;
  const dispatch = useDispatch();
  const translate = useLocalTranslation();
  const copySnippet = () => {
    copy(snippet);
    dispatch(updateBannerInfo(translate('copy_snippet_success'), 'success'));
  };
  const snippet = `
    <script id="pega-wm-chat" src="${process.env.REACT_APP_CHAT_WIDGET_URL}/${widgetId.replace(
    'chat_',
    '',
  )}/widget.js"></script>
    `;

  return (
    <Flex
      container={{
        direction: 'column',
        itemGap: 2,
        alignContent: 'around',
      }}
    >
      {['sdk_mobile'].includes(platform ?? '') && <SDKInstallation platform={platform} />}
      {(!platform || platform === 'combined_messaging') && (
        <>
          <Text variant="h2" as="h2">
            Javascript
          </Text>
          <Text>{translate('copy_snippet_description')}</Text>
          <TextArea value={pretty(snippet)} readOnly={true} style={{ minHeight: 'auto' }} />
          <Flex>
            <Button onClick={copySnippet}>{translate('copy')}</Button>
          </Flex>
        </>
      )}
    </Flex>
  );
};

export default InstallationTab;
